import index from './index.vue'

const router = [
    {
        path: '',
        component: index,
        name: 'settings',
    },
]

export default router;
